import { SERVER_API_PATH } from "api/api-constants";
import { serverApi } from "api/api-server-actions";
import { RubricType } from "components/server-types";
import { withApiErrorReporting } from "utils/api-errors";

export type ExportedOutcome = {
  title: string;
  description: string;
  rubric_descriptions: string[] | null;
};

export type ExportedOutcomeSubgroup = {
  title: string;
  outcomes: ExportedOutcome[];
};

export type ExportedOutcomeGroup = {
  title: string;
  outcomes: ExportedOutcome[];
  subgroups: ExportedOutcomeSubgroup[];
};

export type OutcomeExportFile = {
  version: 1;
  source_organization_name: string;
  rubric: RubricType;
  groups: ExportedOutcomeGroup[];
};

export type OutcomeImportPreview = {
  outcome_export_file: OutcomeExportFile;
  import_token: string;
  destination_rubric_snapshot: RubricType;
  destination_outcome_count_snapshot: number;
  rubric_mismatch: boolean;
  can_replace_rubric: boolean;
};

export type OutcomeImportRubricStrategy = "keep_destination" | "replace_with_source";

export const serverExportOutcomeTree = (
  orgId: string,
  outcomeGroupIds: string[],
  signal: AbortSignal,
) =>
  withApiErrorReporting("outcomeTransfer:export", async () => {
    const response = await serverApi.post<OutcomeExportFile>(
      `${SERVER_API_PATH}/material/outcome_transfer/export/`,
      { group_ids: outcomeGroupIds, org_id: orgId },
      { signal, timeout: 60000 },
    );
    return response.data;
  });

export const serverPreviewOutcomeImport = (
  orgId: string,
  outcomeExportData: unknown,
  signal: AbortSignal,
) =>
  withApiErrorReporting("outcomeTransfer:preview", async () => {
    const response = await serverApi.post<OutcomeImportPreview>(
      `${SERVER_API_PATH}/material/outcome_transfer/preview/`,
      { outcome_export_file: outcomeExportData, org_id: orgId },
      { signal, timeout: 60000 },
    );
    return response.data;
  });

export const serverImportOutcomeTree = (
  orgId: string,
  importToken: string,
  rubricStrategy: OutcomeImportRubricStrategy,
  signal: AbortSignal,
) =>
  withApiErrorReporting("outcomeTransfer:import", async () => {
    const response = await serverApi.post<{ count: number }>(
      `${SERVER_API_PATH}/material/outcome_transfer/import/`,
      { import_token: importToken, rubric_strategy: rubricStrategy, org_id: orgId },
      { signal, timeout: 60000 },
    );
    return response.data;
  });
